export interface PersonalLifetimeThresholdDTO {
  active: boolean;
  value: string;
  actions: Action[];
}

export enum LifetimeThresholdType {
  DEPOSIT = 'deposit',
  NET_LOSS = 'netLoss',
}

export enum Action {
  CREATE_ZENDESK_TICKET = 'CREATE_ZENDESK_TICKET',
  BLOCK_DEPOSIT = 'BLOCK_DEPOSIT',
  FREEZE_ACCOUNT = 'FREEZE_ACCOUNT',
  ACCOUNT_TIMER = 'ACCOUNT_TIMER',
  CREATE_JIRA_TICKET = 'CREATE_JIRA_TICKET',
}

export namespace Action {
  const actionMap: { [key: string]: Action } = {
    freeze: Action.FREEZE_ACCOUNT,
    depositBlock: Action.BLOCK_DEPOSIT,
    accountTimer: Action.ACCOUNT_TIMER,
  };

  export function mapToAction(action: string): Action | undefined {
    return actionMap[action];
  }
}
